var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"back-link",attrs:{"to":_vm.to}},[_c('vb-icon',{attrs:{"name":'chevron-left',"size":14,"color":_vm.sass('info')}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }